module.exports = __webpack_public_path__ + "static/media/web_dealer_logo.ac4e53b7.png";